import type React from "react";
import { cn } from "~/lib/utils";

// // // //

export function ExpandedDetailField(props: {
    label: string;
    value: React.ReactNode;
    emphasize?: boolean;
    title?: string;
    description?: string | null;
}) {
    const { label, value, emphasize = false, title, description } = props;

    const titleAttr =
        title ??
        (typeof value === "string" || typeof value === "number"
            ? String(value)
            : undefined);

    return (
        <div className="space-y-1">
            <p className="text-xs font-normal text-tertiary-foreground">
                {label}
            </p>
            <div
                className={cn(
                    "min-w-0 text-sm font-normal leading-5 text-secondary-foreground",
                    { "text-base leading-tight": emphasize },
                )}
                title={titleAttr}
            >
                {typeof value === "string" ? (
                    <p className="wrap-break-word">{value}</p>
                ) : (
                    value
                )}
            </div>
            {description && (
                <p className="wrap-break-word text-xs font-normal leading-4 text-tertiary-foreground">
                    {description}
                </p>
            )}
        </div>
    );
}
